<app-nested-table-form-field
  [editMode]="editMode"
  [fieldConfig]="fieldConfig"
  (valueChanged)="onValueChanged($event)"
  [canAdd]="true"
  [data]="data"
  [formGroup]="formGroup"
  [fields]="fields"></app-nested-table-form-field>
